// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 598) return "static/chunks/598-52bf8a44734b6d21.js";
	if (chunkId === 642) return "static/chunks/642-7a2b69bf43bf8fee.js";
	if (chunkId === 347) return "static/chunks/347-c92b794d170d29de.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"25":"163e4c6648f98b55","175":"cd7e8464b42fe324","726":"c9fc002a66f72b2f","807":"eba09fa3c9e13e0d","904":"c9b78c11ed999ac1"}[chunkId] + ".js";
};